import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Typography } from '@mui/material'
import {
  TourGuide,
  LayoutFooter,
  MuiImage,
} from '../../components'
import { useGlobalStore } from '../../store'
import { CONST_API_REACT_URL } from '../../constants'
import {
  getImageUrl,
  getLogData,
  timeStampToDate,
} from '../../util'

import {
  OuterWrapper,
  InnerWrapper,
  IconCloseOuterWrapper,
  HeaderRightSection,
  HeaderLeftSection,
  Logo,
} from './style'

const AskIaLayout = ({children, actionButtons}) => {
  const {
    isTourGuideActive,
    theme,
    company,
    projectIdValue,
  } = useGlobalStore()

  const logoFolder = theme === 'dark' ? 'logos/theme-dark' : 'logos/default'
  const logoPath = getImageUrl(logoFolder, company?.CompanyLogo, 'svg')
  const [headerData, setHeaderData] = useState({})
  const navigate = useHistory()

  useEffect(() => {
    getHeaderInfo()
  }, [])

  const getHeaderInfo = () => {
    const headerLogData = projectIdValue.ProjectId
      ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: projectIdValue.ProjectId })[0]
      : {}

    console.log('headerLogData==========', headerLogData, `${CONST_API_REACT_URL}/projects`)
    console.log('headerLogData2==========', headerLogData, !headerLogData?.BrandName, !headerLogData?.CategoryName)
    
    const ls = JSON.parse(window.localStorage.company)
    console.log('---ls.CompanyId ======================', ls.CompanyId,  ls)
    if(ls.CompanyId === 'e0804536-45e9-11ed-bca4-0a1ea4c5532f'){

    }
    else if(headerLogData === undefined){
      window.location.href = `${CONST_API_REACT_URL}/projects`
    }
    
    // if( Object.keys(headerLogData).length === 0 ){
    //   console.log('REDIRECT==========')
    // }

    const fakeHeader = {
      studyId:'',
      brandName:'',
      breadCrumb:'',
      projectType:'',
      subTitle:'',
      lastUpdated:'',
    }

    const headerObj = (ls.CompanyId === 'e0804536-45e9-11ed-bca4-0a1ea4c5532f') ? fakeHeader :{
      studyId: projectIdValue.StudyId,
      brandName: headerLogData?.BrandName || headerLogData?.CategoryName || '',
      breadCrumb: headerLogData?.ProjectType || '',
      projectType: `${headerLogData?.ProjectType || ''}${headerLogData?.ProjectType ? ',' : ''} ${headerLogData?.MarketName || ''}`,
      subTitle: projectIdValue.Period,
      lastUpdated: timeStampToDate(projectIdValue.ModifiedDate),
    }
    setHeaderData(headerObj)
  }

  return (
    <OuterWrapper>
      <IconCloseOuterWrapper>
        <HeaderLeftSection>
          <Logo className='brandLogo'>
            <MuiImage src={logoPath} />
          </Logo>
          <Typography sx={{}} className='brand-name'>
            {headerData?.brandName || ''}
          </Typography>
          <Typography sx={{}} className='project-type'>
            {headerData?.projectType || ''}
          </Typography>
          <Typography className='sub-title'>{headerData?.subTitle}</Typography>
        </HeaderLeftSection>
        <HeaderRightSection>
          {actionButtons}
        </HeaderRightSection>
      </IconCloseOuterWrapper>
      <InnerWrapper>
        {children}
      </InnerWrapper>
      <LayoutFooter isThemed />
      {isTourGuideActive && <TourGuide type='askIa' />}
    </OuterWrapper>
  )
}

export default AskIaLayout
